import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { normalizeApiResponse } from '../../helpers';
import { ResponseApiInterface } from '../../interfaces';
import { ActivationChecklistInterface, GuidedTourId, GuidedTourStateInterface } from '../models';

export interface UpdateGuidedTourPayload {
  status: 'in_progress' | 'dismissed' | 'completed';
  lastStep?: string;
  version: number;
}

export interface OnboardingToursResponse {
  tours?: Partial<Record<GuidedTourId, GuidedTourStateInterface>>;
}

/** Comunicação HTTP do onboarding guiado. A empresa/usuário vêm sempre da sessão. */
@Injectable({ providedIn: 'root' })
export class OnboardingProgressApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.url}/api/v2`;

  getTours(): Observable<OnboardingToursResponse> {
    return this.http
      .get<ResponseApiInterface<OnboardingToursResponse> | OnboardingToursResponse>(
        `${this.baseUrl}/users/me/onboarding`
      )
      .pipe(map((response) => normalizeApiResponse<OnboardingToursResponse>(response).data ?? {}));
  }

  updateTour(tourId: GuidedTourId, payload: UpdateGuidedTourPayload): Observable<void> {
    return this.http
      .patch(`${this.baseUrl}/users/me/onboarding/tours/${encodeURIComponent(tourId)}`, payload)
      .pipe(map(() => undefined));
  }

  getCompanyChecklist(): Observable<ActivationChecklistInterface> {
    return this.http
      .get<ResponseApiInterface<ActivationChecklistInterface> | ActivationChecklistInterface>(
        `${this.baseUrl}/onboarding/company-checklist`
      )
      .pipe(map((response) => normalizeApiResponse<ActivationChecklistInterface>(response).data!));
  }
}
